import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import obtenerTitular from '../../../services/obtenerTitular';
import HistorialPagos from '../../Titulares/HistorialPagos';
import { Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const HistorialPagosPost = () => {

  const { t } = useTranslation();

  const { titularId } = useParams();
  const [titular, setTitular] = useState({});
  const [error, setError] = useState({ error: false, msg: '' });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [coTitular, setCoTitular] = useState(null);

  useEffect(() => {
    obtenerTitular(titularId)
      .then((res) => {
        if (res.status === 200) {
          setTitular(res.data.titular);
        } else {
          setError({ error: true, msg: 'No se logró obtener los datos' });
        }
      })
      .catch((err) => setError({ error: true, msg: err }))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps

    if (titular.referidoId) {
      obtenerTitular(titular.referidoId).then((res) => {
        setCoTitular(res.data.titular);
      });
    }
  }, [titularId]);

  if (error.error) return <div>{t('ERROR')}: {error.msg}</div>
  return (
    <div className="my-3 mx-5">
      <Button
        onClick={() => navigate('/')}
        colorScheme="yellow"
        my="3"
      >
        {t('GO_BACK')}
      </Button>
      <HistorialPagos
        user={titular}
        coTitular={coTitular}
        isLoading={isLoading}
      />
    </div>
  );
};

export default HistorialPagosPost;
